export enum PasswordFeedback {
  VeryStrong = 'Very strong - Excellent!',
  Strong = 'Strong - Acceptable',
  Moderate = 'Moderate - Almost there',
  Weak = 'Weak - Keep going',
  VeryWeak = 'Very Weak - Not enough',
  Nothing = ''
}
